import React from 'react';
import { Link } from 'react-router-dom';

const PublicFooter: React.FC = () => {
  return (
    <footer className="py-10 px-4 sm:px-6 lg:px-8 border-t border-gray-800/60 bg-gray-950">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
        <img
          src="/quanthop_logo_dark.svg"
          alt="Quanthop"
          className="h-5 w-auto opacity-50"
        />
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-gray-600">
          <Link to="/pricing" className="hover:text-gray-400 transition-colors">
            Pricing
          </Link>
          <Link to="/docs" className="hover:text-gray-400 transition-colors">
            Documentation
          </Link>
          <Link to="/learn" className="hover:text-gray-400 transition-colors">
            Learn
          </Link>
          <Link to="/research" className="hover:text-gray-400 transition-colors">
            Research
          </Link>
          <Link to="/blog" className="hover:text-gray-400 transition-colors">
            Blog
          </Link>
          <Link to="/terms" className="hover:text-gray-400 transition-colors">
            Terms
          </Link>
          <Link to="/privacy" className="hover:text-gray-400 transition-colors">
            Privacy
          </Link>
          <Link to="/cookies" className="hover:text-gray-400 transition-colors">
            Cookies
          </Link>
          <Link to="/risk-disclosure" className="hover:text-gray-400 transition-colors">
            Risk Disclosure
          </Link>
        </div>
        <p className="text-xs text-gray-600 font-mono">
          &copy; {new Date().getFullYear()} Quanthop
        </p>
      </div>
    </footer>
  );
};

export default PublicFooter;
